/**
 * Created by Jasmine on 2019/9/19.
 */

// 系统公共本地存储KEY ----start----
const TOKEN_KEY = "token" // 登录token
const NEW_VERSION_KEY = "new-version" // 新版本用户标识
const USER_KEY = "user" // 用户信息

// 系统公共本地存储KEY ----end----


export {
    TOKEN_KEY,
    NEW_VERSION_KEY,
    USER_KEY
}
